import React, { useEffect } from "react";
import Mainlayout from "layouts/main";
import AuthProvider from "contexts/auth";
import AppProvider from "contexts/app"
import WorkspaceProvider from "contexts/workspace"
import { Button, ConfigProvider, Space, App } from 'antd';

//algorithm: theme.darkAlgorithm,
const ThuyTienApp = () => {
    useEffect(() => {
        if (isMobile()) {
            if (window.location.host == "admin.sipro.app")
                window.location = "https://admin2.sipro.app"
        }

    }, [])


    const isMobile = () => {
        if (window.screen.width < 430) {
            return true;
        }
        return false;
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#1677ff',
                },
            }}
        >
            <App>


                <AppProvider>


                    <AuthProvider>

                        <WorkspaceProvider>
                            <Mainlayout></Mainlayout>
                        </WorkspaceProvider>


                    </AuthProvider>
                </AppProvider>
            </App>
        </ConfigProvider>
    );
};

export default ThuyTienApp;
